import { Grid } from "@chakra-ui/react";

import { Legend } from "@nens/lizard/api-v4";

import { REPORT_BLOCK_INTERNAL_GAP } from "@/features/report/consts/sizes";

import { LegendDiscreteStep } from "./legend-discrete-step";

interface LegendDiscreteProps {
  legend: Legend["legend"];
  labels: Legend["labels"];
  isAboveMap?: boolean;
}

export function LegendDiscrete({ legend, labels, isAboveMap }: LegendDiscreteProps) {
  const selectedLabels = labels["nl_NL"] || labels["en_EN"];
  if (!selectedLabels) return null;

  return (
    <Grid
      rowGap={REPORT_BLOCK_INTERNAL_GAP}
      {...(isAboveMap
        ? {
            templateRows: "repeat(3, 1fr)",
            autoFlow: "column",
            columnGap: 4,
          }
        : {
            templateColumns: "1fr",
          })}
    >
      {legend.map((step, i) => {
        const label = selectedLabels[step.value] || "Other";
        return (
          <LegendDiscreteStep key={step.value + step.color + i} label={label} color={step.color} />
        );
      })}
    </Grid>
  );
}
